import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

// Holds the BIC mask the current IBAN resolves to in a ref and re-runs the BIC
// field's mismatch validation whenever that mask changes.
export const useIbanBicMismatchSync = (
	ibanBicMask: string | null,
	bicFieldName: string,
	ibanFieldName = 'beneficiary.account',
): RefObject<string | null> => {
	const { trigger, getValues } = useFormContext();
	const ibanBicMaskRef = useRef<string | null>(null);
	const ibanValue = useWatch({ name: ibanFieldName });

	useEffect(() => {
		const prevBicMask = ibanBicMaskRef.current;
		const nextBicMask = ibanValue ? ibanBicMask : null;
		ibanBicMaskRef.current = nextBicMask;
		if (getValues(bicFieldName) && (nextBicMask !== null || prevBicMask !== null)) {
			trigger(bicFieldName);
		}
	}, [ibanBicMask, ibanValue, bicFieldName, trigger, getValues]);

	return ibanBicMaskRef;
};
